import { render } from "./letter-forward-step3.vue?vue&type=template&id=0370e90c"
import script from "./letter-forward-step3.vue?vue&type=script&lang=js"
export * from "./letter-forward-step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__